import { JSX } from 'react';
import { Checkbox, FormControlLabel, Grid2 as Grid, TableCell, TableRow } from '@mui/material';
import { ExcelExportExtendedModel } from 'api';
import { COMPLETED_VALUE } from '../../../constants';

const ReportStatusRow = ({
  reportStatus,
  icon,
  handleIndividualChange,
  checked,
}: {
  reportStatus: ExcelExportExtendedModel;
  icon: JSX.Element;
  handleIndividualChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
}) => (
  <TableRow>
    <TableCell sx={{ width: '50%' }}>
      <FormControlLabel
        disabled={reportStatus.status !== COMPLETED_VALUE}
        control={
          <Checkbox
            onChange={handleIndividualChange}
            checked={checked}
            indeterminate={reportStatus.status !== COMPLETED_VALUE}
            id={reportStatus.company_measurement_date.toString()}
          />
        }
        label={reportStatus.company_name}
      />
    </TableCell>
    <TableCell sx={{ width: '50%' }}>
      <Grid container direction="row">
        <Grid>{icon}</Grid>
        <Grid sx={{ marginLeft: '1.25em', paddingTop: '0.3em' }}>{reportStatus.status_label}</Grid>
      </Grid>
    </TableCell>
  </TableRow>
);

export default ReportStatusRow;
